/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathXDivideY2 = createReactComponent("outline", "math-x-divide-y-2", "IconMathXDivideY2", [["path", { "d": "M3 21l18 -18", "key": "svg-0" }], ["path", { "d": "M15 14l3 4.5", "key": "svg-1" }], ["path", { "d": "M21 14l-4.5 7", "key": "svg-2" }], ["path", { "d": "M3 4l6 6", "key": "svg-3" }], ["path", { "d": "M3 10l6 -6", "key": "svg-4" }]]);

export { IconMathXDivideY2 as default };
//# sourceMappingURL=IconMathXDivideY2.mjs.map
